import "./chunk--chunk-Z7A6LSGX.vbt.js";

// src/js/components/VerifyPassword.js
var VerifyPassword = class {
  constructor(el) {
    this.el = el;
    this.input = el.querySelector("input");
    this.characterCountEl = el.querySelector("[data-character-count]");
    this.minChar = this.characterCountEl.getAttribute("data-character-count");
    this.letterEl = el.querySelector("[data-letter]");
    this.numberEl = el.querySelector("[data-number]");
    this.progressBar = el.querySelector("[data-progress-bar]");
    this.strengthEl = el.querySelector("[data-strength]");
  }
  init() {
    this.input.addEventListener("input", () => this.handleInput());
    this.handleInput();
  }
  handleInput() {
    let strengthVal = 0;
    const characterCount = this.input.value.length;
    if (characterCount >= this.minChar) {
      strengthVal += 1;
    }
    if (this.input.value.match(/[a-z]/)) {
      strengthVal += 1;
    }
    if (this.input.value.match(/[0-9]/)) {
      strengthVal += 1;
    }
    this.letterEl.classList.toggle("active", this.input.value.match(/[a-zA-Z]/));
    this.characterCountEl.classList.toggle("active", characterCount >= this.minChar);
    this.numberEl.classList.toggle("active", this.input.value.match(/[0-9]/));
    this.progressBar.style.width = `${strengthVal * (100 / 3)}%`;
    this.strengthEl.classList.remove("weak", "medium", "strong");
    this.progressBar.classList.remove("weak", "medium", "strong");
    const strength = ["", "weak", "medium", "strong"][strengthVal];
    this.strengthEl.textContent = strength;
    if (strength !== "") {
      this.strengthEl.classList.add(strength);
      this.progressBar.classList.add(strength);
    }
  }
};
var VerifyPassword_default = VerifyPassword;
export {
  VerifyPassword_default as default
};
